'use strict';

function Select(){

    /********************************/
    // Init select2
    /********************************/
    this.initSelects = function () {
        var select2Options = {
            placeholder: 'Choose an option'
        };

        if ($('#school').length > 0) {
            $('#school').select2(select2Options);
        }
        if ($('#country').length > 0) {
            $('#country').select2(select2Options);
        }

        $('select[multiple="multiple"]').css('width','100%').select2(select2Options);
    };
}